import * as Dialog from '@radix-ui/react-dialog';
import { animated, config, useTransition } from '@react-spring/web';
import type { CSSProperties } from 'react';
import { forwardRef } from 'react';

type ModalBackgroundProps = {
  isOpen: boolean;
};

export const ModalBackground = forwardRef<HTMLDivElement, ModalBackgroundProps>(({ isOpen }, ref) => {
  const overlayTransitions = useTransition(isOpen, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: config.stiff,
  });

  return (<>
    {overlayTransitions((transitionStyle, item) => item ? (
      <animated.div ref={ref} style={transitionStyle as unknown as CSSProperties} className="fixed inset-0 z-40 tds-modal-background">
        <Dialog.Overlay />
      </animated.div>
    ) : null)}
  </>);
});
